module.exports = __webpack_public_path__ + "img/future-city.7c6c2661.jpg";